import { render, staticRenderFns } from "./ProductData.vue?vue&type=template&id=b2bc72a8&"
import script from "./ProductData.vue?vue&type=script&lang=js&"
export * from "./ProductData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports